module.exports = __webpack_public_path__ + "static/img/0 main.c4c3b701.jpg";